import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { SelectOption } from './select.component.interface';

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.css'],
})
export class SelectComponent implements OnInit {
  @Input() controlForm: FormControl = new FormControl();
  @Input() placeholder: string = 'Selecciona';
  @Input() title: string = '';
 
  @Input() hintText: string = '';
  @Input() textInformation: string = '';
  @Input() shouldShowArrow: boolean = true;
  @Input() optional: boolean = false;
  @Input() biggerOptionSpace: boolean = false;
  @Input() biggerOptionWidth: boolean = false;
  @Input() color: 'default' | 'white' = 'default';
  @Input() optionalTooltip :  boolean =  false;
  @Input() textTooltip :  string = ''

  @Input()
  get options(): SelectOption[] {
    return this._options;
  }
  set options(options: SelectOption[]) {
    this._options = options;
    if (this.controlForm.value) {
      let selectedValue = this.options.find(({ id }) => id === +this.controlForm.value);
      if (selectedValue) {
        selectedValue = <SelectOption>selectedValue;
        this.falseInputControlForm.patchValue(selectedValue.value);
        this.formContainer.nativeElement.blur();
      }
    }
  }
  private _options: SelectOption[] = [];

  @ViewChild('formContainer') formContainer: ElementRef;

  falseInputControlForm: FormControl = new FormControl();

  focus: boolean = false;

  constructor(
    private ref: ElementRef,
  ) {
    this.formContainer = ref;
  }

  ngOnInit(): void {
    this.controlForm.valueChanges.subscribe({
      next: (selectedId) => {
        if (selectedId === null) {
          this.falseInputControlForm.reset();
        }
        else {
          let selectedValue = this.options.find(({ id }) => id === +selectedId);
          if (selectedValue) {
            selectedValue = <SelectOption>selectedValue;
            this.falseInputControlForm.patchValue(selectedValue.value);
            this.formContainer.nativeElement.blur();
          }
        }
      },
    });
  }

  handleFocus() {
    this.focus = true;
  }

  handleBlur() {
    this.focus = false;
  }

  onSelectValue(event: MouseEvent) {
    const selectedId = (<any>event.target).id as string;
    let selectedValue = this.options.find(({ id }) => id === +selectedId);
    if (selectedValue) {
      selectedValue = <SelectOption>selectedValue;
      this.falseInputControlForm.patchValue(selectedValue.value);
      this.controlForm.patchValue(selectedId);
      this.formContainer.nativeElement.blur();
    }
  }

}
